import { CHARGE_STATUS } from '@/types/charge-status';
import { cn } from '@/utils/cn';
import React from 'react';
import { Text, View } from 'react-native';

export const statusLabels: Record<CHARGE_STATUS, string> = {
  [CHARGE_STATUS.PAID]: 'Pago',
  [CHARGE_STATUS.PENDING]: 'Pendente',
  [CHARGE_STATUS.OVERDUE]: 'Vencido',
  [CHARGE_STATUS.CANCELED]: 'Cancelado',
  [CHARGE_STATUS.REFUNDED]: 'Reembolsado',
  [CHARGE_STATUS.PARTIALLY_REFUNDED]: 'Parcialmente Reembolsado',
  [CHARGE_STATUS.IN_DISPUTE]: 'Em Disputa',
  [CHARGE_STATUS.PAYMENT_REPORTED]: 'Pgto. Informado',
};

interface ChargeStatusBadgeProps {
  status: CHARGE_STATUS;
  className?: string;
}

export function ChargeStatusBadge({ status, className }: ChargeStatusBadgeProps) {
  const variants: Record<CHARGE_STATUS, string> = {
    [CHARGE_STATUS.PAID]: 'bg-success-50 text-success-600 border-success-200',
    [CHARGE_STATUS.PENDING]: 'bg-warning-50 text-warning-600 border-warning-200',
    [CHARGE_STATUS.OVERDUE]: 'bg-error-50 text-error-600 border-error-200',
    [CHARGE_STATUS.REFUNDED]: 'bg-neutral-50 text-neutral-600 border-neutral-200',
    [CHARGE_STATUS.PARTIALLY_REFUNDED]: 'bg-neutral-100 text-neutral-700 border-neutral-300',
    [CHARGE_STATUS.CANCELED]: 'bg-neutral-50 text-neutral-600 border-neutral-200',
    [CHARGE_STATUS.IN_DISPUTE]: 'bg-warning-100 text-warning-700 border-warning-300',
    [CHARGE_STATUS.PAYMENT_REPORTED]: 'bg-premium-50 text-premium-600 border-premium-200',
  };

  return (
    <View className={cn('rounded-full border px-2 py-1', variants[status], className)}>
      {/* No nativo o `text-*` da View não chega ao Text: repete só a cor nele. */}
      <Text className={cn('font-medium text-xs', variants[status].match(/\btext-\S+/)?.[0])}>
        {statusLabels[status]}
      </Text>
    </View>
  );
}
